/** Logo ids available in public/logos.svg (the marks shown in the mockups). */
export type LogoId =
  | 'orq'
  | 'anthropic'
  | 'openai'
  | 'google'
  | 'azure'
  | 'openrouter'
  | 'lmstudio'
  | 'bc'
  | 'sharepoint'
  | 'outlook'
  | 'odoo'
  | 'github'
  | 'devops'
  | 'entra'
  | 'word'
  | 'excel'
  | 'powerpoint'
  | 'teams'
  | 'onedrive'
  | 'powerbi'
  | 'microsoft'
  | 'cloudflare'
  | 'huggingface'
  | 'context7'
  | 'leexi';

const IDS = new Set<string>([
  'orq',
  'anthropic',
  'openai',
  'google',
  'azure',
  'openrouter',
  'lmstudio',
  'bc',
  'sharepoint',
  'outlook',
  'odoo',
  'github',
  'devops',
  'entra',
  'word',
  'excel',
  'powerpoint',
  'teams',
  'onedrive',
  'powerbi',
  'microsoft',
  'cloudflare',
  'huggingface',
  'context7',
  'leexi',
]);

export function isLogoId(value: string | undefined): value is LogoId {
  return Boolean(value) && IDS.has(value as string);
}

/** Decorative: the adjacent name labels it. */
export function Logo({ id }: { id: LogoId }) {
  return (
    <svg aria-hidden="true" focusable="false">
      <use href={`#logo-${id}`} />
    </svg>
  );
}
